module.exports = __webpack_public_path__ + "img/12217_14.8a6a1c76.png";